<h1 mat-dialog-title>Barcode not found</h1>
<mat-dialog-content style="color: #ffffff87">Try again or search manually</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="mat-raised-button ok-button" (click)="search()">Search</button>
  <button mat-button class="" mat-dialog-close>Try again</button>
</mat-dialog-actions>
